import React from "react"
import HeroSection from "../components/marketing/HeroSection"
import { BatchContactWidget } from "../components/ui/BatchContactWidget"
import ServicesPreview from "../components/marketing/ServicesPreview"
import WhySection from "../components/marketing/WhySection"
import ProcessSection from "../components/marketing/ProcessSection"
import CTASection from "../components/marketing/CTASection"
import StatsBar from "../components/marketing/StatsBar"
import TestimonialsSection from "../components/marketing/TestimonialsSection"
import AICapabilitiesShowcase from "../components/marketing/AICapabilitiesShowcase"


export default function Home() {
  return (
    <div>
      <HeroSection />

      <div className="max-w-7xl mx-auto px-6 py-24">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-white mb-4">Try Our AI Extraction Pipeline</h2>
          <p className="text-slate-400">Experience enterprise-grade contact resolution in your browser.</p>
        </div>
        <BatchContactWidget />
      </div>

      <StatsBar />
      <AICapabilitiesShowcase />
      <ServicesPreview />
      <WhySection />
      <ProcessSection />
      <CTASection />

    </div>
  )
}

